export default {
  name: 'marking--pdInformation',
  apiService: 'shoes',
  apiPath: '/admin/pd_information_h',
};
